import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import ScoPicker from '~/pages/scorm/components/ScoPicker'

const CHAPTERS = ['intro', 'basics', 'quiz'] as const

/**
 * Le sélecteur de chapitres en démonstration (#160) : un module à trois
 * chapitres, le premier fait, de quoi le montrer dans les visites du lecteur.
 */
function DemoChapterPicker() {
  const { t } = useTranslation()
  const [chapter, setChapter] = useState<string>('basics')
  const scos = CHAPTERS.map(key => ({ identifier: key, title: t(`help.demo.chapters.${key}`), href: '' }))

  return <ScoPicker scos={scos} active={chapter} completed={new Set(['intro'])} onSelect={setChapter} />
}

export default DemoChapterPicker
